'use client';

import CmsBlockGroup from '@/components/CmsBlock';
import { websiteEnv } from '@/constants/website-env';
import classes from './termsConditionsPage.module.css';

export const TermsConditionsPage = () => {
  return (
    <div className={classes.termsconditions}>
      <h1 className={classes.title}>TERMS &amp; CONDITIONS</h1>
      <CmsBlockGroup
        classes={{
          root: classes.con,
        }}
        identifiers={
          websiteEnv.isUnitedStates
            ? 'terms-and-conditions'
            : `terms-and-conditions-${process.env.NEXT_PUBLIC_STORE_VIEW_CODE}`
        }
        resolveRelativePath={!!process.env.NEXT_PUBLIC_BASE_PATH}
      />
    </div>
  );
};

export default TermsConditionsPage;
